import { AnyAction, createSelector, createSlice, Slice } from '@reduxjs/toolkit';
import { TAppDispatch, TState } from '~/src/store';
import { getCities } from '~/src/services/api/api-content/geography/get-all-cities';
import { getTariffsAliases } from '~/src/services/api/api-content/cities/alias';
import { ApiCity } from '~/src/services/api/api-content/geography/types';

interface IModalParams {
    isShow: boolean;
}

interface IAppSlice {
    modals: {
        [name: string]: IModalParams;
    };
    cities: ApiCity[];
    tariffsAlias: { bundles: string[], mono: string[] };
    breakpoint: string;
    isLoading: boolean;
}

const appSlice: Slice<IAppSlice> = createSlice({
    name: 'app',
    initialState: {
        modals: {},
        breakpoint: 'desktop',
        cities: [],
        tariffsAlias: { bundles: [], mono: [] },
        isLoading: false,
    },
    reducers: {
        getCities: (state: IAppSlice, action: AnyAction) => {
            state.cities = action.payload;
        },
        getTariffsAliases: (state: IAppSlice, action: AnyAction) => {
            state.tariffsAlias = action.payload;
        },
        changeParams: (state: IAppSlice, action: AnyAction) => {
            state.modals = action.payload;
        },
        changeBreakpoint: (state: IAppSlice, action: AnyAction) => {
            state.breakpoint = action.payload;
        },
        startLoading: (state: IAppSlice) => {
            state.isLoading = true;
        },
        stopLoading: (state: IAppSlice) => {
            state.isLoading = false;
        },
    },
});
const { actions } = appSlice;

export const { changeBreakpoint } = actions;

export const getAllCities = () => {
    return async (dispatch: TAppDispatch) => {
        const cities = await getCities();
        dispatch(actions.getCities(cities));
    };
};

export const getAllTariffsAliases = () => {
    return async (dispatch: TAppDispatch) => {
        const response = await getTariffsAliases();
        response.isSuccess && dispatch(actions.getTariffsAliases(response.payload));
    };
};

export const changeModalParams = (modalName: string, params: IModalParams) => {
    return (dispatch: TAppDispatch, getState: () => TState): void => {
        const { app: { modals } } = getState();

        dispatch(actions.changeParams({
            ...modals,
            [modalName]: params,
        }));
    };
};

export const startLoading = () => {
    return (dispatch: TAppDispatch): void => {
        dispatch(actions.startLoading(null));
    };
};

export const stopLoading = () => {
    return (dispatch: TAppDispatch): void => {
        dispatch(actions.stopLoading(null));
    };
};

export const selectApp = (state: TState): IAppSlice => {
    return state.app;
};

const selectCities = (state: TState) => state.app.cities;

export const selectCitiesNames = createSelector(
    selectCities,
    cities => cities.map((item) => item.name)
);

export const tariffsAlias = (state: TState) => {
    return state.app.tariffsAlias;
};

export default appSlice.reducer;
